'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_utils$ChangeSet(added, removed, elements) {
  this.NL = null;
  this.NM = null;
  this.y0 = null;
  this.NL = added;
  this.NM = removed;
  this.y0 = elements;
}
export { $c_Lpresto_utils$ChangeSet as $c_Lpresto_utils$ChangeSet };
$p = $c_Lpresto_utils$ChangeSet.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_utils$ChangeSet;
/** @constructor */
function $h_Lpresto_utils$ChangeSet() {
}
export { $h_Lpresto_utils$ChangeSet as $h_Lpresto_utils$ChangeSet };
$h_Lpresto_utils$ChangeSet.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_hashing_MurmurHash3$().S(this, (-889275714), false);
});
$p.i = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lpresto_utils$ChangeSet)) {
    var x = this.NL;
    var x$2 = x$0.NL;
    if (((x === null) ? (x$2 === null) : x.i(x$2))) {
      var x$3 = this.NM;
      var x$4 = x$0.NM;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : x$3.i(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$5 = this.y0;
      var x$6 = x$0.y0;
      return ((x$5 === null) ? (x$6 === null) : x$5.i(x$6));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.l = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().H(this);
});
$p.r = (function() {
  return 3;
});
$p.s = (function() {
  return "ChangeSet";
});
$p.j = (function(n) {
  switch (n) {
    case 0: {
      return this.NL;
      break;
    }
    case 1: {
      return this.NM;
      break;
    }
    case 2: {
      return this.y0;
      break;
    }
    default: {
      throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.adP = (function() {
  return ((!this.NL.k()) || (!this.NM.k()));
});
function $isArrayOf_Lpresto_utils$ChangeSet(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.mq)));
}
export { $isArrayOf_Lpresto_utils$ChangeSet as $isArrayOf_Lpresto_utils$ChangeSet };
var $d_Lpresto_utils$ChangeSet = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_utils$ChangeSet, "presto.utils$ChangeSet", ({
  mq: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lpresto_utils$ChangeSet as $d_Lpresto_utils$ChangeSet };
//# sourceMappingURL=presto.utils$-Change-Set.js.map
